import { Gamepad2, Wallet, History, User } from "lucide-react";
import { theme } from "../assets/theme";

const NAV_ITEMS = [
  { label: "Game", Icon: Gamepad2, id: "game" },
  { label: "Wallet", Icon: Wallet, id: "wallet" },
  { label: "History", Icon: History, id: "history" },
  { label: "Profile", Icon: User, id: "profile" },
];

function NavTab({ item, active, onClick }) {
  const { Icon } = item;
  const color = active ? theme.color.accentLight : theme.color.textFaint;

  return (
    <button
      onClick={() => onClick(item.id)}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "4px",
        padding: "8px 12px",
        borderRadius: theme.radius.md,
        position: "relative",
        background: "transparent",
        border: "none",
        cursor: "pointer",
      }}
    >
      <Icon
        size={20}
        color={color}
        style={{
          filter: active
            ? `drop-shadow(0 0 5px ${theme.color.accentGlow})`
            : "none",
        }}
      />

      <span
        style={{
          fontSize: "10px",
          fontWeight: theme.font.weightSemi,
          color,
          textTransform: "uppercase",
          letterSpacing: "0.1em",
          fontFamily: theme.font.bodyFamily,
        }}
      >
        {item.label}
      </span>

      {active && (
        <span
          style={{
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "28px",
            height: "2px",
            borderRadius: theme.radius.full,
            background: theme.color.accent,
            boxShadow: theme.shadow.glowBar,
          }}
        />
      )}
    </button>
  );
}

export default function BottomNav({ activeTab, setActiveTab }) {
  return (
    <nav
      style={{
        borderTop: `1px solid ${theme.color.border}`,
        background: theme.color.bgNav,
        backdropFilter: "blur(12px)",
        padding: "8px 16px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        zIndex: 9999,
      }}
    >
      {NAV_ITEMS.map((item) => (
        <NavTab
          key={item.id}
          item={item}
          active={activeTab === item.id}
          onClick={setActiveTab}
        />
      ))}
    </nav>
  );
}
